import type { CourierId } from './ids/ids';

/** Характеристики курьера (шкала 1–10 в UI выбора персонажа). */
export type CharacterStats = {
  speed: number;
  control: number;
  power: number;
};

export type CharacterId = CourierId;

export const CHARACTER_STAT_MAX = 10;

/**
 * Статы курьеров из v1 `catalog/courierStats` (GDD).
 * Поле `control` = v1 `handling`.
 */
export const CHARACTER_STATS: Record<CharacterId, CharacterStats> = {
  eddy: { speed: 10, control: 4, power: 2 },
  claudi: { speed: 6, control: 8, power: 4 },
  tuchi: { speed: 3, control: 6, power: 7 },
  ufo: { speed: 7, control: 6, power: 3 },
  vall: { speed: 4, control: 3, power: 10 },
  rock: { speed: 6, control: 5, power: 9 },
};

export function getCharacterStats(id: CharacterId): CharacterStats {
  return CHARACTER_STATS[id];
}
